<template>
  <v-dialog :value="show" max-width="500" @input="(val) => outsideClick(val)">
    <v-card class="align-center d-flex flex-column">
      <CloseDialogButton :close="closeAuth" />
      <StorefrontImage class="display-none-height pt-10" size="large" />
      <PhoneLogInContent
        :closeAuth="closeAuth"
        :phone="phone"
        :toAuthRoute="toAuthRoute"
        :toLogInRoute="toLogInRoute"
        :updatePhone="updatePhone"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import CloseDialogButton from "@/components/UI/CloseDialogButton.vue";
import PhoneLogInContent from "@/components/Auth/LogIn/Content/Phone.vue";
import StorefrontImage from "@/components/UI/StorefrontImage.vue";

export default {
  name: "PhoneLogInDialog",
  components: {
    CloseDialogButton,
    PhoneLogInContent,
    StorefrontImage,
  },
  props: {
    closeAuth: Function,
    outsideClick: Function,
    phone: String,
    show: Boolean,
    toAuthRoute: Function,
    toLogInRoute: Function,
    updatePhone: Function,
  },
};
</script>
<style scoped>
@media (max-height: 768px) {
  .display-none-height {
    display: none;
  }
}
</style>
